import { IIconProps } from '@cian/ui-kit-design-tokens/internal/types';
import * as React from 'react';

export const IconStrokeLike16 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1188_379463)">
        <path
          d="M12.657 13H6.00016L6.00016 5.30145L8.55605 1.44733C8.74132 1.16796 9.05423 1 9.38945 1H9.50672V5V6H10.5067L14.0244 6C14.7348 6 15.2186 6.71993 14.9503 7.37768L12.657 13ZM1 6L2 6L2 13H1L1 6Z"
          stroke={currentColor}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1188_379463">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
